import type { ReservationState } from '@digitalopsdev/serviceops-reservations-components/dist/EditReservation/model';
import { useBulkState, useModelState } from '@digitalopsdev/serviceops-reservations-components/dist/utils/useModelState';

/** Subscribe to native fields; the normal and Puck confirmations share the same live state. */
export function useConfirmationState(state: ReservationState) {
    useBulkState(state.ProgramBookings, [p => p.Start, p => p.End, p => p.ProgramType, p => p.Price.price]);
    useBulkState(state.RoomBookings, [r => r.CheckIn, r => r.CheckOut, r => r.RoomType, r => r.CalculatedPrice]);
    useModelState(state.AmountPayableTotal);
    useModelState(state.AmountDueTotal);
    useModelState(state.PosItems);
}
